import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {CompanySliceType} from "./Types";
import {Customer} from "../../Models/Customer";

const initialState : CompanySliceType = {
  companies: [],
  companies_branches: [],
  branchList: [],
};

const CompanySlice = createSlice({
  name:"Company",
  initialState,
  reducers : {
    setCompany(state, {payload}: PayloadAction<any>){
      state.companies = payload?.companies;
      state.companies_branches =  payload?.companies_branches;
    },
    setCompanySelected(state,{payload} : PayloadAction<any>){
      state.company_selected = payload;
    },
    setBranchSelected(state,{payload} : PayloadAction<any>){
      state.branch_selected = payload;
    },
    setBranchList(state, {payload}: PayloadAction<Customer[]>) {
      state.branchList = payload;
    },
    clearState: state => initialState
  }
});

export const CompanyActions = CompanySlice.actions;

export default CompanySlice.reducer;
